import { TranslateService } from '@ngx-translate/core';
import { Component, AfterViewInit, OnInit, Input, OnDestroy } from "@angular/core";
import { FormGroup } from '@angular/forms';
import * as L from 'leaflet';
import 'leaflet-draw';

import * as turf from '@turf/turf';
import { Farm } from 'src/app/shared/dtos/Farm';
import { MapService } from '../../map.service';
import { MapStyleService } from "../../map-style.service";
import { Observable, Subscription } from "rxjs";
import { TownHall } from "src/app/shared/dtos/TownHall";

@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.css']
})
export class Step2Component implements AfterViewInit, OnInit, OnDestroy {

  private MAP_ID = 'map2';
  private map: L.map;

  @Input() formParent: FormGroup;
  @Input() formParentStepOne: FormGroup;
  @Input() allFarms: Farm[];
  @Input() farmId: number;
  @Input() ubication: any;

  farmsSelected: Farm[];

  panelOpenState = false;
  townHallSelected$: Observable<TownHall>;
  subscriptions: Subscription[] = [];
  latitude = '';
  longitude = '';
  drawnItems = undefined;
  drawControl: L.Control;

  constructor(private mapService: MapService, private mapStyleService: MapStyleService, private translate: TranslateService) { }

  ngAfterViewInit(): void {
    //CREATE MAP
    this.map = L.map(this.MAP_ID, this.mapService.getDefaultCreateFarmMapOptions());
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    //crear funcionalidades de leaflet.draw
    this.drawnItems = new L.FeatureGroup();
    this.map.addLayer(this.drawnItems);

    L.control.layers(this.mapService.getBaseLayers()
    , this.mapService.getOverLayers(), { collapsed: false }).addTo(this.map);

    //modificar los textos del tooltip y toolbar
    this.mapStyleService.getDrawCustomOptions();

    //Asignar propiedades al toolbar
    this.drawControl = this.mapStyleService.getDrawControlFarms(this.drawnItems, (this.formParent.get('geometry').value !== ""));
    this.map.addControl(this.drawControl);

    this.centerUbication();

    //gestión de eventos
    this.manageEvents(this.drawnItems);
    this.showMyFarms();
    this.showAllFarms();
  }

  showMyFarms(): void {
    const geometryFarm = this.formParent.get('geometry').value;
    if (geometryFarm){
      const geojson = L.geoJSON(geometryFarm, {
        style: {
          weight: 2,
          opacity: 1,
          color: 'red',
          dashArray: '3',
          fillOpacity: 0.7,
        }
      }).addTo(this.map);
      this.map.flyTo(geojson.getBounds().getCenter(), 12, {animate: false});
      this.addNonGroupLayers(geojson, this.drawnItems);
    }
  }

  showAllFarms(): void {
    if (this.allFarms !== undefined) {
      this.farmsSelected = this.allFarms.map( pol => pol.geometry);
      const farmId = this.farmId;
      this.allFarms.forEach(element => {
        if (element.id !== Number(farmId)){
          L.geoJSON(element.geometry).addTo(this.map);
        }
      });
    }
  }

  addNonGroupLayers(sourceLayer, targetGroup) {
    if (sourceLayer instanceof L.LayerGroup) {
      sourceLayer.eachLayer((layer) => {
        this.addNonGroupLayers(layer, targetGroup);
      });
    } else {
      targetGroup.addLayer(sourceLayer);
    }
  }

  private manageEvents(drawnItems: any) {
    //Event created
    this.map.on('draw:created', (e) => {
      const layer = e.layer;
      const latlang = layer._latlngs[0][0];
      const geojson = layer.toGeoJSON();
      const area = (turf.area(e.layer.toGeoJSON()) / 10000).toFixed(2);
      const popup = L.popup()
      .setLatLng(latlang)
      .setContent(`<p style='color: #5e9ca0; text-align: center;'><strong>${this.translate.instant('FARM.POPUP.FARM_CREATED')}</strong></p>
      <p style='text-align: center;'>&nbsp;${this.translate.instant('FARM.POPUP.HECTARES_SELECTED')}: "${area}"</p>
      <p style='text-align: center;'>&nbsp;${this.translate.instant('FARM.POPUP.NEXT')}</p>`).openOn(this.map);

      if (this.farmsSelected.length === 0) {
        this.formParent.get('geometry').setValue(geojson.geometry);
        layer.openPopup(popup);
      }
      this.farmsSelected.map((element) => {
        if (turf.intersect(element, geojson) != null) {
          alert('No se pueden superponer las fincas');
          this.map.removeLayer(layer);
        }
        else {
          this.formParent.get('geometry').setValue(geojson.geometry);
          layer.openPopup(popup);
        }
      });
      drawnItems.addLayer(layer);
    });
    //Event edited
    this.map.on('draw:edited', (e) => {
      if (e.layers.getLayers()[0]){
        const newLayer = e.layers.getLayers()[0].toGeoJSON();
        this.formParent.get('geometry').setValue(newLayer.geometry);
      }
    });
    //Event deleted
    this.map.on('draw:deleted', (e) => {
      this.formParent.get('geometry').setValue("");
    });
  }

  centerUbication(): void {
    if (this.formParentStepOne.get("country").value === 'es'){
      let townHallUbication = this.ubication.townHall;
      if (townHallUbication){
        this.latitude = townHallUbication.latitude;
        this.longitude = townHallUbication.longitude;
        if (this.latitude !== '' && this.longitude !== '' &&
        this.latitude != undefined && this.longitude != undefined){
          const centerCordinatesByParam = [];
          centerCordinatesByParam.push(parseFloat(this.latitude.replace(/,/g, '.')));
          centerCordinatesByParam.push(parseFloat(this.longitude.replace(/,/g, '.')));
          this.map.flyTo(new L.latLng(centerCordinatesByParam), 12);
        }
      }
    }
    else {
      let municipalityUbication = this.ubication.municipality;
      if (municipalityUbication){
        this.latitude = municipalityUbication.latitude;
        this.longitude = municipalityUbication.longitude;
        if (this.latitude !== '' && this.longitude !== '' &&
        this.latitude != undefined && this.longitude != undefined){
          const centerCordinatesByParam = [];
          centerCordinatesByParam.push(parseFloat(this.latitude.replace(/,/g, '.')));
          centerCordinatesByParam.push(parseFloat(this.longitude.replace(/,/g, '.')));
          this.map.flyTo(new L.latLng(centerCordinatesByParam), 12);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subs => {
      subs.unsubscribe();
    });
  }

  ngOnInit(): void {

  }

}
